import type { ReactNode } from "react";

export function DashboardPrimaryGrid({ children }: { children: ReactNode }) {
  return <section className="dashboard-primary-grid" aria-label="Resumen del proyecto">{children}</section>;
}
